<script lang="ts">
import {Country} from '@mapit/common-utils/dist/types'
import {computed, defineComponent, PropType} from '@vue/composition-api'

import AddressFormGroup from '@/components/repairshop/AddressFormGroup.vue'
import OpeningHoursSchedule from '@/components/repairshop/OpeningHoursSchedule.vue'
import {getCountry, PostalAddress} from '@/utils/administrative-region-helper'

export default defineComponent({
  name: 'LocationFormGroup',
  components: {
    OpeningHoursSchedule,
    AddressFormGroup,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    translationPrefix: {
      type: String,
      required: false,
    },
    dealerCountry: {
      type: String as PropType<Country>,
      required: false,
    },
  },
  setup(props) {
    const country = computed(() => {
      return getCountry(props.value.address as PostalAddress, props.dealerCountry)
    })

    return {
      country,
      location: props.value,
    }
  },
})
</script>

<template>
  <div v-if="value">
    <address-form-group
      :dealer-country="dealerCountry"
      :translation-prefix="translationPrefix"
      v-model="location.address" />

    <m-form-row :label="$t(`${translationPrefix}-address-phone`)">
      <m-phone-field
        :country="country"
        :forced-prefix="true"
        :placeholder="$t('contact.form.lbl-phone-placeholder')"
        data-cy="address-phone"
        v-model="location.telephone" />
    </m-form-row>

    <m-form-row class="mt-2">
      <template v-slot:custom-label>
        <div class="align-self-start">{{ $t(`${translationPrefix}-openingtimes`) }}</div>
      </template>

      <template v-slot:default>
        <opening-hours-schedule class="mt-2" v-model="location.openingHours" />
      </template>
    </m-form-row>
  </div>
</template>
